// generated from 1_343 samples

import { z } from "zod";
import { common } from "../common";
import { filterGetBaseSchema } from "./filterGetBaseSchema";

export const controlGroupFilterGetSchema = z.object({
  ...filterGetBaseSchema.shape,
  filter_key: z.literal("control_group_filter"),
  comparison_key: z.enum([
    "2", // 1_203 (89.58%)
    "1", // 140 (10.42%)
  ]),
  display_name: z.string(),
  // undefined: 655 (48.77%), defined 688 (51.23%)
  raw_value: common.objectId.optional(),
  value: z.object({
    // true 124 (9.23%), false 1_219 (90.77%)
    expired: z.boolean(),
    id: common.objectId,
    value: z.string(),
  }),
  varies_by_app_group: z.literal(true),
});
